import { AppIcon } from '@/components/ui/app-icon';
import { Logo } from '@/components/logo.component';
import { useSignupsPaused } from '@/hooks/use-signups-paused.hook';
import { peekPostAuthRedirect } from '@/lib/post-auth-redirect';
import { AuthenticateWithRedirectCallback } from '@clerk/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useEffect } from 'react';
import { iconSpinnerThird } from '@/lib/icons';

export const Route = createFileRoute('/auth/sso-callback')({
  component: SSOCallbackPage,
});

function SSOCallbackPage() {
  const navigate = useNavigate();
  const signupsPaused = useSignupsPaused();

  useEffect(() => {
    const handleError = () => {
      const params = new URLSearchParams(window.location.search);
      const error = params.get('error');

      if (error) {
        navigate({
          to: '/auth/error',
          search: {
            error: error,
            error_description: params.get('error_description') || undefined,
          },
        });
      }
    };

    handleError();
  }, [navigate]);

  return (
    <div className='flex min-h-screen items-center justify-center bg-linear-to-br from-slate-50 via-white to-slate-50 p-4 dark:bg-black'>
      <div className='w-full max-w-md text-center'>
        <Logo className='mx-auto mb-6 h-8 w-auto' />
        <div className='rounded-lg border border-slate-200 bg-white p-8 shadow-xl dark:border-slate-800 dark:bg-slate-900'>
          <AppIcon
            icon={iconSpinnerThird}
            className='mx-auto mb-4 animate-spin text-[#3E8BFF]'
            style={{ fontSize: 32 }}
          />
          <h2 className='mb-2 text-lg font-semibold text-foreground'>
            Completing authentication...
          </h2>
          <p className='text-sm text-muted-foreground'>
            Please wait while we complete your sign in
          </p>
        </div>

        <AuthenticateWithRedirectCallback
          signInFallbackRedirectUrl={peekPostAuthRedirect() ?? '/'}
          signUpFallbackRedirectUrl={peekPostAuthRedirect() ?? '/'}
          continueSignUpUrl='/auth/register'
          // ponytail: reads PostHog's persisted flags at mount (set on the
          // login page before the OAuth redirect); a cold first visit that
          // lands here with no cache still transfers. Clerk Restricted mode
          // closes that.
          transferable={!signupsPaused}
        />
      </div>
    </div>
  );
}

export default SSOCallbackPage;
